<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Edit Schedule</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <form>
    <div class="form-group" [formGroup]="form">
      <div class="row">
        <div class="col-md-6" >
          <div class="form-group">
            <label>Scheduled Start Time</label>
            <p-calendar class="form-control" formControlName="scheduledStartTime" dateFormat="dd/mm/yy" [minDate]="minDate" [showTime]="true" [hideOnDateTimeSelect]="false" panelStyleClass="popupAboveDate"></p-calendar>
          </div>
        </div>
        <div class="col-md-6" >
          <div class="form-group">
            <label>Scheduled End Time</label>
            <p-calendar class="form-control" formControlName="scheduledEndTime" dateFormat="dd/mm/yy" [minDate]="minDate" [showTime]="true" [hideOnDateTimeSelect]="false" panelStyleClass="popupAboveDate"></p-calendar>
          </div>
        </div>
      </div>
      <div *ngIf="validationErrors.length" class="validation-box text-danger">
        Please fix the following validation problems to continue:
        <div *ngFor="let validationError of validationErrors">- {{validationError.message}}</div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onSubmit()" [disabled]="saveInProgress || !form.valid || !form.dirty" class="btn btn-sm btn-success">Save</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
